// extracted by mini-css-extract-plugin
module.exports = {"buttonStyles":"Button-module__buttonStyles___2XRvV"};